<kodit-dropdown
  [options]="items"
  [formCtrl]="mesecCtrl"
  (optionChanged)="handleOnItemChange($event)"
>
</kodit-dropdown>
